import { Grid } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { useSelector } from 'modules/react-redux';
import { PreviewToggleButton } from 'pages/requestForm/components/SplitViewWrapper/components/PreviewToggleButton/PreviewToggleButton';
import ActionsBlock from 'pages/requestForm/containers/form/ActionsBlock/ActionsBlock';
import { requestSelector } from 'pages/requestForm/selectors/pageSelectors';
import { memo } from 'react';
import { FeatureBadge } from 'shared/components';

export const HeaderActions = memo(() => {
    const request = useSelector(requestSelector);
    const company = useSelector((state) => selectors.company.getCompanyById(state, request.companyId));

    return (
        <Grid gap={16} gridAutoFlow='column' alignItems='center'>
            <FeatureBadge premium={company.flags.isAllFeaturesTrialActive || company.flags.isTrialLicense} />

            <PreviewToggleButton />

            <ActionsBlock />
        </Grid>
    );
});

HeaderActions.displayName = 'HeaderActions';
